export default "__VITE_ASSET__ZHuLSbSP__"